import Vue from 'vue';
import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';
import './scss/index.scss';
import 'vue2-datepicker/locale/ko';

Vue.component('DatePicker', DatePicker);
